<template>
  <div ref="main" class="datacenter" style="margin: 0;height: 100%;">
    <div class="legends">
      <div class="item" v-for="(c, i) in fleet" :key="'f' + i" :class="`legend${i + 1}`">
        <div class="label">{{ c.nickname }}</div>
        <div class="field" :class="`color${i + 1}`"></div>
      </div>
    </div>

    <div class="tabs">
      <div ref="tab1" class="tab tab1 active" data-idx="1" @click="showPage1">基础信息</div>
      <div ref="tab2" class="tab tab2" data-idx="2" @click="showPage0">环比信息</div>
    </div>

    <div class="btns clearfix">
      <div class="label fleft">查看车队详情</div>
      <div v-for="(c, i) in fleet" :key="'fl' + i" class="btn fleft" :class="`btn${i}`" :data-idx="i"
        :data-id="c.nickname" @click="viewFleet(c)">{{ c.nickname }}</div>
    </div>

    <div class="mainContent clearfix">
      <div ref="drawer" class="drawer clearfix">
        <div class="page page0 clearfix">
          <div class="left clearfix">
            <div class="col box1">
              <div class="unit">单位：元</div>
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div ref="box1wrap" class="wrap"></div>
            </div>
            <div class="col box2">
              <div class="unit">单位：元</div>
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div ref="box2wrap" class="wrap"></div>
            </div>
            <div class="col box3">
              <div class="unit">单位：元</div>
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div ref="box3wrap" class="wrap"></div>
            </div>
            <div class="col box5">
              <div class="unit">单位：元</div>
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div ref="box5wrap" class="wrap"></div>
            </div>
            <div class="col box6">
              <div class="unit">单位：元</div>
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div ref="box6wrap" class="wrap"></div>
            </div>
            <div class="col box7">
              <div class="unit">单位：元</div>
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div ref="box7wrap" class="wrap"></div>
            </div>
          </div>
          <div class="right clearfix">
            <div class="row box4">
              <div ref="box4wrap" class="wrap"></div>
            </div>
            <div class="hoop box8">
              <div class="title">车辆利润率</div>
              <div class="circle circle0 row0 col0">
                <div ref="circle0wrap" class="wrap"></div>
                <div ref="circle0num" class="num"></div>
                <div ref="circle0name" class="name"></div>
              </div>
              <div class="circle circle1 row0 col1">
                <div ref="circle1wrap" class="wrap"></div>
                <div ref="circle1num" class="num"></div>
                <div ref="circle1name" class="name"></div>
              </div>
              <div class="circle circle2 row0 col2">
                <div ref="circle2wrap" class="wrap"></div>
                <div ref="circle2num" class="num"></div>
                <div ref="circle2name" class="name"></div>
              </div>
              <div class="circle circle3 row1 col0">
                <div ref="circle3wrap" class="wrap"></div>
                <div ref="circle3num" class="num"></div>
                <div ref="circle3name" class="name"></div>
              </div>
              <div class="circle circle4 row1 col1">
                <div ref="circle4wrap" class="wrap"></div>
                <div ref="circle4num" class="num"></div>
                <div ref="circle4name" class="name"></div>
              </div>
              <div class="circle circle5 row1 col2">
                <div ref="circle5wrap" class="wrap"></div>
                <div ref="circle5num" class="num"></div>
                <div ref="circle5name" class="name"></div>
              </div>
              <div class="subTitle subTitle0">本月数据</div>
              <div class="subTitle subTitle1">上月数据</div>
            </div>
          </div>
        </div>
        <div class="page page1">
          <div v-for="(c, i) in fleet" :key="'flt' + i" class="convoy" :class="`convoy${i}`">
            <div class="title">{{ c.nickname }}车队</div>
            <div class="chart0 type0 fleft">
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div :ref="`c${i}0wrap`" class="wrap"></div>
            </div>
            <div class="chart1 type0 fleft">
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div :ref="`c${i}1wrap`" class="wrap"></div>
            </div>
            <div class="chart2 type0 fleft">
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div :ref="`c${i}2wrap`" class="wrap"></div>
            </div>
            <div class="chart3 type1 fleft">
              <div class="line line0"></div>
              <div class="line line1"></div>
              <div class="line line2"></div>
              <div class="line line3"></div>
              <div class="line line4"></div>
              <div class="line line5"></div>
              <div :ref="`c${i}3wrap`" class="wrap"></div>
            </div>
            <div class="chart4 type2 fleft"></div>
            <div class="chart5 type3 fleft">
              <div :ref="`c${i}5wrap`" class="wrap"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog class="dialog" ref="dialog" :title="title">
      <template #default>
        <Table ref="table" :tableData="tableData" :cols="cols" />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "FinancialAnalysis",
  data() {
    return {
      baseUrl: 'datacenter',
      fleet: [],
      NAMES: [],
      CHARTS: [],
      BAR: 'bar',
      TITLE_STYLE: {
        color: '#D0D2D4',
        fontSize: 17,
        fontWeight: 500,
        textShadowOffsetX: 0,
        textShadowOffsetY: 3,
        textShadowBlur: 6,
        textShadowColor: 'rgba(0, 0, 0, 0.3)',
      },
      TEXT_STYLE: {
        color: '#A8A9AA',
        fontSize: 14,
        textShadowOffsetX: 0,
        textShadowOffsetY: 2,
        textShadowBlur: 4,
        textShadowColor: 'rgba(0, 0, 0, 0.3)',
      },
      GRID: {
        left: 0,
        right: 0,
        bottom: '12%',
        height: '70%',
      },
      BAR_BORDER_RADIUS: [10, 10, 2, 2],
      BAR_WIDTH: 26,
      COLOR: [
        '#025CBE',
        '#009FFB',
        '#4D3983',
        '#735DE6',
        '#0EA7AD',
        '#0CE1E6',
      ],
      COLORA: [
        'rgba(2,92,190,0.6)',
        'rgba(0,159,251,0.6)',
        'rgba(77,57,131,0.6)',
        'rgba(115,93,230,0.6)',
        'rgba(14,167,173,0.6)',
        'rgba(12,225,230,0.6)',
      ],
      data: {},
      titles: ['单车平均运单额', '单车平均费用', '单车平均毛利润', '曲线图', '运单平均值'],
      cols: [
        { keyName: 'id', label: 'ID', sort: true },
        { keyName: 'license', label: '车牌号' },
        { keyName: 'driver', label: '司机姓名' },
        { keyName: 'freight', label: '运单总额' },
        { keyName: 'total', label: '费用总额' },
        { keyName: 'profit', label: '利润总额' },
        { keyName: 'advfreight', label: '平均运费' },
        { keyName: 'advtotal', label: '平均费用' },
        { keyName: 'advprofit', label: '平均利润' },
      ],
      title: '',
      tableData: [],
    };
  },
  methods: {
    showDialog(str = 'dialog') {
      this.$refs[str] && this.$refs[str].show()
    },
    viewFleet({ id, nickname }) {
      this.title = nickname
      let url = `${this.baseUrl}/centerec`;
      const params = {
        fleet: id,
      }
      this.post(url, params, (res) => {
        const { data } = res
        this.tableData = data
        this.showDialog()
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getFleet() {
      this.loading = true
      let url = `${this.baseUrl}/getfleet`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        const { msg, data } = res
        if (msg === 'success' && data) {
          // console.log(res)
          this.fleet = data
          this.NAMES = data.map(v => v.nickname)
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    scale(v) {
      const vw = this.$refs.main.clientWidth;
      // console.log(this.$refs.main)
      // console.log(vw)
      return v * vw / 1920
    },
    setRem() {
      const Doc = document.documentElement
      Doc.style.fontSize = this.scale(100) + 'px'
      // console.log(Doc.style.fontSize)
      // alert(Doc.clientWidth + ' ' + Doc.clientHeight)
      // if (Doc.clientWidth < 1920) {
      //   Doc.style.overflowX = 'scroll'
      //   Doc.style.overflowY = 'hidden'
      // }
      // if (Doc.clientHeight < 1080) {
      //   Doc.style.overflowY = 'scroll'
      //   Doc.style.overflowX = 'hidden'
      // }
      // if (Doc.clientWidth == 1920) {
      //   Doc.style.overflowX = 'hidden'
      // }
      // if (Doc.clientHeight == 1080) {
      //   Doc.style.overflowY = 'hidden'
      // }
    },
    showPage1() {
      this.$refs.tab2.classList.remove('active')
      this.$refs.tab1.classList.add('active')
      this.$refs.drawer.style.marginLeft = 0
    },
    showPage0() {
      this.$refs.tab1.classList.remove('active')
      this.$refs.tab2.classList.add('active')
      this.$refs.drawer.style.marginLeft = '-18.4rem'
    },
    $_(str) {
      return this.$refs[str]
    },
    chartInit(selector) {
      var box = this.$_(selector)
      // console.log(selector, box)
      if (!box) return
      if (box.length == 1) box = box[0]
      var myChart = this.$echarts.init(box)
      myChart.showLoading();
      this.CHARTS.push(myChart)
    },
    pageInit() {
      for (let i = 0; i < 8; i++) {
        if (i === 7) {
          var j = 0
          while (j < 6) {
            this.chartInit('circle' + (j++) + 'wrap')
          }
        } else if (i === 3) {
          this.chartInit('box' + (i + 1) + 'wrap')
        } else {
          this.chartInit('box' + (i + 1) + 'wrap')
        }
      }
      // console.log(this.CHARTS)
      for (var i1 = 0; i1 < 3; i1++) {
        for (var j1 = 0; j1 < 5; j1++) {
          let selector = ''
          if (j1 < 3) {
            selector = 'c' + i1 + '' + j1 + 'wrap'
          } else if (j1 == 3) {
            selector = 'c' + i1 + '3wrap'
          } else if (j1 == 4) {
            selector = 'c' + i1 + '5wrap'
          }
          this.chartInit(selector)
        }
      }
      // console.log(this.CHARTS)
      // this.getData()
      this.$nextTick(() => {
        this.setData()
      })
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/datacenter`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        const { msg } = res
        if (msg === 'success') {
          // console.log(res)
          this.data = res
          this.pageInit()
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setData() {
      const res = this.data
      const X_DATA = res.month
      const months = res.pmonth
      let aveorder2 = res.aveorder2.slice(-2) || [];
      let avefeiyong2 = res.avefeiyong2.slice(-2) || [];
      let aveprofit2 = res.aveprofit2.slice(-2) || [];
      let aveorder10 = res.aveorder10.slice(-2) || [];
      let avefeiyong10 = res.avefeiyong10.slice(-2) || [];
      let aveprofit10 = res.aveprofit10.slice(-2) || [];
      let aveorder102 = res.aveorder102.slice(-2) || [];
      let avefeiyong102 = res.avefeiyong102.slice(-2) || [];
      let aveprofit102 = res.aveprofit102.slice(-2) || [];
      // console.log(this.CHARTS)
      this.CHARTS.forEach((v, i) => {
        // console.log(v, i)
        v.hideLoading()
        var option = {}
        switch (i) {
          case 0:
            // console.log(v)
            option = this.getChartOption({
              title: '车队运费总额',
              data: res.allfreight
            })
            // console.log(option)
            break;
          case 1:
            option = this.getChartOption({
              title: '费用总额',
              data: res.allfax
            })
            break;
          case 2:
            option = this.getChartOption({
              title: '毛利润总额',
              data: res.allprofit
            })
            break;
          case 3:
            option = this.getRowChartOption({
              title: '费效系数',
              passLine: 0.5,
              data: res.allcoeff,
            })
            break;
          case 4:
            option = this.getChartOption({
              title: '单车平均运费',
              data: res.averagefreight
            })
            break;
          case 5:
            option = this.getChartOption({
              title: '单车平均费用',
              data: res.averagefax
            })
            break;
          case 6:
            option = this.getChartOption({
              title: '单车平均毛利润',
              data: res.averageprofit
            })
            break;
          case 7:
          case 10:
            option = this.getCircleChartOption({
              colorS: this.COLOR[0],
              colorE: this.COLOR[1],
              data: res.profitmargin[i - 7],
              name: this.NAMES[0]
            })
            var num = this.$_(`circle${(i - 7)}num`)
            num.innerHTML = res.profitmargin[i - 7] + '%'
            var name = this.$_(`circle${(i - 7)}name`)
            name.innerHTML = this.NAMES[0]
            break;
          case 8:
          case 11:
            option = this.getCircleChartOption({
              colorS: this.COLOR[2],
              colorE: this.COLOR[3],
              data: res.profitmargin[i - 7],
              name: this.NAMES[1]
            })
            this.$_(`circle${(i - 7)}num`).innerHTML = res.profitmargin[i - 7] + '%'
            this.$_(`circle${(i - 7)}name`).innerHTML = this.NAMES[1]
            break;
          case 9:
          case 12:
            option = this.getCircleChartOption({
              colorS: this.COLOR[4],
              colorE: this.COLOR[5],
              data: res.profitmargin[i - 7],
              name: this.NAMES[2]
            })
            this.$_(`circle${(i - 7)}num`).innerHTML = res.profitmargin[i - 7] + '%'
            this.$_(`circle${(i - 7)}name`).innerHTML = this.NAMES[2]
            break;
          case 13:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[0],
              xData: X_DATA,
              yData: aveorder2,
            })
            break;
          case 14:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[1],
              xData: X_DATA,
              yData: avefeiyong2,
            })
            break;
          case 15:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[2],
              xData: X_DATA,
              yData: aveprofit2,
            })
            break;
          case 16:
            option = this.getConvoyLineChartOption({
              x: i,
              title: this.titles[3],
              xData: months,
              yData: [
                res.aveorder2,
                res.avefeiyong2,
                res.aveprofit2,
              ],
            })
            break;
          case 17:
            option = this.getConvoyRowChartOption({
              x: i,
              title: this.titles[4],
              data: res.jieaverage
            })
            break;
          case 18:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[0],
              xData: X_DATA,
              yData: aveorder10,
            })
            break;
          case 19:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[1],
              xData: X_DATA,
              yData: avefeiyong10,
            })
            break;
          case 20:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[2],
              xData: X_DATA,
              yData: aveprofit10,
            })
            break;
          case 21:
            option = this.getConvoyLineChartOption({
              x: i,
              title: this.titles[3],
              xData: months,
              yData: [
                res.aveorder10,
                res.avefeiyong10,
                res.aveprofit10,
              ],
            })
            break;
          case 22:
            option = this.getConvoyRowChartOption({
              x: i,
              title: this.titles[4],
              data: res.yangaverage
            })
            break;
          case 23:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[0],
              xData: X_DATA,
              yData: aveorder102,
            })
            break;
          case 24:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[1],
              xData: X_DATA,
              yData: avefeiyong102,
            })
            break;
          case 25:
            option = this.getConvoyChartOption({
              x: i,
              title: this.titles[2],
              xData: X_DATA,
              yData: aveprofit102,
            })
            break;
          case 26:
            option = this.getConvoyLineChartOption({
              x: i,
              title: this.titles[3],
              xData: months,
              yData: [
                res.aveorder102,
                res.avefeiyong102,
                res.aveprofit102,
              ],
            })
            break;
          case 27:
            option = this.getConvoyRowChartOption({
              x: i,
              title: this.titles[4],
              data: res.xuaverage
            })
            break;
        }
        v.setOption(option)
      })
    },
    getBarColor(color1, color2) {
      var result = new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
        offset: 0,
        color: color1 // 0% 处的颜色
      }, {
        offset: 1,
        color: color2 // 100% 处的颜色
      }], false)

      result.reverse = () => {
        return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: color1 // 0% 处的颜色
        }, {
          offset: 1,
          color: color2 // 100% 处的颜色
        }], false)
      }

      return result
    },
    getRowBarColor(color1, color2) {
      return new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
        offset: 0,
        color: color1 // 0% 处的颜色
      }, {
        offset: 1,
        color: color2 // 100% 处的颜色
      }], false)
    },
    getChartOption(params) {
      // console.log(params)
      return {
        title: {
          text: params.title,
          padding: [5, 0],
          left: 'center',
          textStyle: this.TITLE_STYLE
        },
        xAxis: {
          data: this.NAMES,
          axisLine: {
            show: false
          },
        },
        yAxis: {
          show: false
        },
        // tooltip: {
        //     show: true
        // },
        series: [{
          name: params.title,
          type: this.BAR,
          data: params.data,
          label: {
            show: true,
            position: 'top'
          },
          barWidth: this.BAR_WIDTH,
          itemStyle: {
            borderRadius: this.BAR_BORDER_RADIUS,
            color: (params) => {
              var list = [
                this.getBarColor(this.COLOR[0], this.COLOR[1]),
                this.getBarColor(this.COLOR[2], this.COLOR[3]),
                this.getBarColor(this.COLOR[4], this.COLOR[5]),
              ]
              return list[params.dataIndex]
            }
          },
        }],
        grid: this.GRID,
        textStyle: this.TEXT_STYLE,
      }
    },
    getRowChartOption(params) {
      return {
        title: {
          text: params.title,
          padding: [5, 0],
          left: 'center',
          textStyle: this.TITLE_STYLE
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          data: this.NAMES,
          show: true,
          inverse: true,
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 20
          }
        },
        // tooltip: {
        //     show: true
        // },
        grid: {
          left: 58,
          right: '10%',
          bottom: '12%',
          width: '80%',
          height: 176,
        },
        textStyle: this.TEXT_STYLE,
        series: [{
          name: params.title,
          type: this.BAR,
          data: params.data,
          label: {
            show: true,
            position: 'right'
          },
          barWidth: this.BAR_WIDTH,
          itemStyle: {
            borderRadius: 3,
            color: (params) => {
              var list = [
                this.getRowBarColor(this.COLOR[0], this.COLOR[1]),
                this.getRowBarColor(this.COLOR[2], this.COLOR[3]),
                this.getRowBarColor(this.COLOR[4], this.COLOR[5]),
              ]
              return list[params.dataIndex]
            }
          },
          markLine: {
            symbol: ['none', 'none'], //去掉箭头
            itemStyle: {
              lineStyle: {
                type: 'solid',
                color: '#F56C6C',
                width: 2
              },
              label: { show: false }
            },
            data: [{
              xAxis: params.passLine || 0.4
            }]
          }
        }],
      }
    },
    getCircleChartOption(params) {
      return {
        polar: {
          // radius: ['0%', '74%'] //图的半径，跟饼图的一样的配置
        },
        angleAxis: {
          splitNumber: 10, // 坐标轴分割段数
          min: 0,
          max: 100,
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.COLOR[0],
              width: 1
            },
          },
          axisTick: {
            show: false
          }
        },
        radiusAxis: {
          type: 'category',
          data: ['', '', '', ''],
          inverse: true,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          }
        },
        series: [{
          name: '车辆利润率',
          type: this.BAR,
          data: [params.data],
          barWidth: this.BAR_WIDTH,
          coordinateSystem: 'polar',
          roundCap: true,
          itemStyle: {
            color: this.getBarColor(params.colorE, params.colorS)
          }
        }],
        // tooltip: {
        //     show: true
        // },
      };
    },
    getConvoyChartOption(params) {
      var titleStyle = { ...this.TITLE_STYLE }

      titleStyle.fontSize = 16

      var colorS = this.COLOR[0]
      var colorE = this.COLOR[1]
      var colorSp = this.COLORA[0]
      var colorEp = this.COLORA[1]

      if ([18, 19, 20].includes(params.x)) {
        colorS = this.COLOR[2]
        colorE = this.COLOR[3]
        colorSp = this.COLORA[2]
        colorEp = this.COLORA[3]
      } else if ([23, 24, 25].includes(params.x)) {
        colorS = this.COLOR[4]
        colorE = this.COLOR[5]
        colorSp = this.COLORA[4]
        colorEp = this.COLORA[5]
      }

      return {
        title: {
          text: params.title,
          padding: [5, 0],
          left: 'center',
          textStyle: titleStyle
        },
        xAxis: {
          data: params.xData,
          axisLine: {
            show: false
          },
        },
        yAxis: {
          show: false
        },
        // tooltip: {
        //     show: true
        // },
        series: [{
          name: params.title,
          type: this.BAR,
          data: params.yData,
          label: {
            show: true,
            position: 'top',
            fontSize: 12
          },
          barWidth: this.BAR_WIDTH,
          itemStyle: {
            borderRadius: this.BAR_BORDER_RADIUS,
            color: (params) => {
              var list = [
                this.getBarColor(colorSp, colorEp),
                this.getBarColor(colorS, colorE),
              ]
              return list[params.dataIndex]
            }
          },
        }],
        grid: {
          left: 0,
          right: 0,
          bottom: '11%',
          height: '70%',
        },
        textStyle: this.TEXT_STYLE,
      }
    },
    getConvoyLineChartOption(params) {
      var titleStyle = { ...this.TITLE_STYLE }

      titleStyle.fontSize = 16

      var markPoint = {
        label: {
          show: true,
          position: 'top',
          distance: 6,
          color: '#A8A9AA',
          fontSize: 12,
          backgroundColor: '#313242',
          padding: [6, 12],
          borderRadius: 5,
          shadowOffsetX: 0,
          shadowOffsetY: 2,
          shadowBlur: 4,
          shadowColor: 'rgba(0, 0, 0, 0.06)',
          borderColor: '#2D2E3D',
          borderWidth: 1,
          lineHeight: 10,
        },
        symbol: 'circle',
        symbolSize: 10,
        symbolOffset: [0, 0],
        data: [{
          type: 'max',
          name: '最大值'
        }]
      }

      var colors = ['#009EFA', '#725CE5', '#0CE0E5']

      return {
        title: {
          text: params.title,
          padding: [5, 0],
          textStyle: titleStyle
        },
        legend: {
          show: true,
          textStyle: this.TEXT_STYLE,
          data: [
            { name: '运单额' },
            { name: '费用' },
            { name: '利润' },
          ],
          align: 'right',
          itemGap: 20,
        },
        color: colors,
        xAxis: {
          data: params.xData,
          axisLine: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          max: 100000,
          splitNumber: 5,
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 14,
            margin: 0,
            padding: 0,
          },
          splitLine: {
            show: false
            // show: true,
            // lineStyle: {
            //     color: '#44455D',
            //     width: 2,
            //     type: 'doted',
            // }
          }
        },
        grid: {
          left: 50,
          right: 0,
          bottom: '11%',
          width: '90%',
          height: '70%',
        },
        textStyle: this.TEXT_STYLE,
        // tooltip: {
        //     show: true
        // },
        series: [{
          name: '运单额',
          type: 'line',
          smooth: true,
          symbol: 'none',
          data: params.yData[0],
          label: {
            show: true,
            fontSize: 12
          },
          lineStyle: {
            color: colors[0]
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
              offset: 0,
              color: 'rgba(0, 158, 250, 0)'
            }, {
              offset: 1,
              color: 'rgba(0, 158, 250, 0.25)'
            }], false),
          },
          markPoint: markPoint
        },
        {
          name: '费用',
          type: 'line',
          smooth: true,
          symbol: 'none',
          data: params.yData[1],
          label: {
            show: true,
            fontSize: 12
          },
          lineStyle: {
            color: colors[1]
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
              offset: 0,
              color: 'rgba(114, 92, 229, 0)'
            }, {
              offset: 1,
              color: 'rgba(114, 92, 229, 0.25)'
            }], false),
          },
          markPoint: markPoint
        },
        {
          name: '利润',
          type: 'line',
          smooth: true,
          symbol: 'none',
          data: params.yData[2],
          label: {
            show: true,
            fontSize: 12
          },
          lineStyle: {
            color: colors[2]
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
              offset: 0,
              color: 'rgba(12, 224, 229, 0)'
            }, {
              offset: 1,
              color: 'rgba(12, 224, 229, 0.25)'
            }], false),
          },
          markPoint: markPoint
        }
        ],
      }
    },
    getConvoyRowChartOption(params) {
      var titleStyle = { ...this.TITLE_STYLE }

      titleStyle.fontSize = 16

      var colorS = this.COLOR[0]
      var colorE = this.COLOR[1]
      var colorSp = this.COLORA[0]
      var colorEp = this.COLORA[1]

      if (params.x == 22) {
        colorS = this.COLOR[2]
        colorE = this.COLOR[3]
        colorSp = this.COLORA[2]
        colorEp = this.COLORA[3]
      } else if (params.x == 27) {
        colorS = this.COLOR[4]
        colorE = this.COLOR[5]
        colorSp = this.COLORA[4]
        colorEp = this.COLORA[5]
      }

      return {
        title: {
          text: params.title,
          padding: [5, 0],
          left: 'center',
          textStyle: titleStyle
        },
        xAxis: {
          show: false,
          max: 5000
        },
        yAxis: {
          data: ['本月', '上月', '历史同期'],
          show: true,
          inverse: true,
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 15
          }
        },
        // tooltip: {
        //     show: true
        // },
        grid: {
          left: 66,
          right: '10%',
          bottom: '4%',
          width: '70%',
          height: 176,
        },
        textStyle: this.TEXT_STYLE,
        series: [{
          name: params.title,
          type: this.BAR,
          data: params.data,
          label: {
            show: true,
            position: 'right',
            distance: 10
          },
          barWidth: this.BAR_WIDTH,
          itemStyle: {
            borderRadius: 3,
            // color: this.getRowBarColor(colorS, colorE),
            color: (params) => {
              var list = [
                this.getRowBarColor(colorS, colorE),
                this.getBarColor(colorSp, colorEp),
                this.getBarColor(colorSp, colorEp),
              ]
              return list[params.dataIndex]
            }
          },
        }],
      }
    },
  },
  mounted() {
    this.getFleet()
    this.setRem()
    // this.pageInit()
    this.getData()
  },
};
</script>

<style lang="less" scoped>
.datacenter {
  background: #393A4B;
  position: relative;
  font-size: 0.17rem;
  color: #D0D2D4;
  overflow: hidden;

  .legends {
    position: absolute;
    top: 0.48rem;
    left: 0.5rem;
    font-size: 0.16rem;
    font-weight: 400;
    color: #A8A9AA;
    text-shadow: 0px 2px 4px rgb(0 0 0 / 30%);

    .item {
      float: left;
      margin-right: 0.5rem;

      .label {
        float: left;
        height: 0.16rem;
        line-height: 0.16rem;
        margin-right: 0.15rem;
      }

      .field {
        width: 0.4rem;
        height: 0.16rem;
        box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
        float: left;
        box-sizing: border-box;
      }
    }
  }

  .color1 {
    background: linear-gradient(90deg, #025CBE 0%, #009FFB 100%);
  }

  .color2 {
    background: linear-gradient(90deg, #4D3983 0%, #735DE6 100%);
  }

  .color3 {
    background: linear-gradient(90deg, #0EA7AD 0%, #0CE1E6 100%);
  }

  .tabs {
    width: 2.4rem;
    height: 0.43rem;
    line-height: 0.43rem;
    border-radius: 0.05rem;
    position: absolute;
    top: 0.34rem;
    left: 50%;
    transform: translateX(-50%);
    color: #D0D2D4;
    border: 1px solid #2B2C3A;
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;

    .tab {
      float: left;
      width: 50%;
      height: 100%;
      cursor: pointer;

      &.active {
        background: #46485E;
      }
    }
  }

  .fleft {
    float: left;
  }

  .btns {
    font-size: 0.16rem;
    position: absolute;
    right: 0.375rem;
    top: 0.355rem;

    .label {
      color: #767778;
      padding: 0 0.25rem;
      margin-top: 0.125rem;
      margin-right: 0.125rem;
      border-right: 1px solid #767778;
    }

    .btn {
      padding: 0.125rem;
      box-sizing: border-box;
      color: #A8A9AA;
      cursor: pointer;
    }
  }

  .mainContent {
    position: absolute;
    left: 0.4rem;
    top: 0.97rem;
    width: 18.4rem;
    overflow: hidden;

    .line {
      background-image: url(../assets/img/doteed.png);
      background-repeat: no-repeat;
      background-size: 4rem;
      width: 3.51rem;
      height: 0.52rem;
      position: absolute;
      top: 0.73rem;
      left: 0.2rem;
    }

    .drawer {
      width: 36.8rem;
      transition: all .5s;

      .page {
        width: 18.4rem;
        float: left;

        .left {
          float: left;
          width: 12.33rem;

          .col {
            width: 3.91rem;
            height: 4rem;

            .unit {
              font-size: 0.12rem;
              font-weight: 400;
              color: #767778;
              text-shadow: 0px 2px 4px rgb(0 0 0 / 30%);
              position: absolute;
              top: 0.24rem;
              right: 0.2rem;
            }

            .line0 {
              top: 0.73rem;
            }

            .line1 {
              top: 1.25rem;
            }

            .line2 {
              top: 1.78rem;
            }

            .line3 {
              top: 2.3rem;
            }

            .line4 {
              top: 2.83rem;
            }

            .line5 {
              top: 3.35rem;
            }

            .wrap {
              width: 3.51rem;
              height: 3.6rem;
            }
          }
        }

        .right {
          float: left;
          width: 6.07rem;

          .row {
            width: 5.87rem;
            height: 3.13rem;

            .wrap {
              width: 5.47rem;
              height: 2.73rem;
            }
          }

          .hoop {
            width: 5.87rem;
            height: 4.86rem;

            .title {
              font-weight: 500;
              text-shadow: 0px 3px 6px rgb(0 0 0 / 30%);
              position: absolute;
              top: 0.2rem;
              /* left: 0.2rem; */
              left: 50%;
              transform: translateX(-50%);
            }

            .circle {
              width: 1.4rem;
              height: 1.4rem;
              border-radius: 50%;
              border: 1px solid rgba(0, 0, 0, 0.10196078431372549);
              position: absolute;
              top: 0.72rem;
              left: 0.4rem;

              .wrap {
                width: 100%;
                height: 100%;
                margin: 0;
              }

              .num {
                position: absolute;
                width: 100%;
                text-align: center;
                top: 0.53rem;
                text-shadow: 0px 2px 4px rgb(0 0 0 / 30%);
              }

              .name {
                position: absolute;
                width: 100%;
                text-align: center;
                top: 0.75rem;
                text-shadow: 0px 2px 4px rgb(0 0 0 / 30%);
                font-size: 0.12rem;
                color: #A8A9AA;
              }

              &.row0 {
                top: 0.72rem;
              }

              &.row1 {
                top: 2.82rem;
              }

              &.col0 {
                left: 0.4rem;
              }

              &.col1 {
                left: 2.24rem;
              }

              &.col2 {
                left: 4.07rem;
              }
            }

            .subTitle {
              font-weight: 500;
              font-size: 0.14rem;
              color: #A8A9AA;
              position: absolute;
              width: 100%;
              text-align: center;
            }

            .subTitle0 {
              top: 2.27rem;
            }

            .subTitle1 {
              top: 4.37rem;
            }
          }
        }
      }

      .page1 {
        .convoy {
          width: 18.2rem;
          height: 2.6rem;
          background: #2B2C3A;
          border-radius: 5px;
          margin: 0.1rem 0.1rem 0.2rem;
          position: relative;

          .title {
            width: 0.59rem;
            height: 1.59rem;
            border: 2px solid rgba(0, 0, 0, 0.2);
            box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
            border-radius: 1px 15px 15px 1px;
            position: absolute;
            top: 0.51rem;
            left: -0.03rem;
            padding: 0.2rem;
            box-sizing: border-box;
            font-weight: 600;
          }

          &.convoy0 .title {
            background: linear-gradient(180deg, #039EF1 0%, #025CBE 100%);
          }

          &.convoy1 .title {
            background: linear-gradient(180deg, #735DE6 0%, #4D3983 100%);
          }

          &.convoy2 .title {
            background: linear-gradient(180deg, #0CE1E6 0%, #0EA7AD 100%);
          }

          .fleft {
            position: relative;

            .line {
              width: 100%;
              height: 0.52rem;
              position: absolute;
              left: 0;
            }

            .line0 {
              top: 0.42rem;
            }

            .line1 {
              top: 0.74rem;
            }

            .line2 {
              top: 1.06rem;
            }

            .line3 {
              top: 1.38rem;
            }

            .line4 {
              top: 1.7rem;
            }

            .line5 {
              top: 2.02rem;
            }

            .wrap {
              width: 100%;
              height: 100%;
              margin: 0;
            }
          }

          .type0 {
            width: 2.18rem;
            height: 2.3rem;
            margin: 0.15rem 0.15rem;
          }

          .type1 {
            width: 4.33rem;
            height: 2.3rem;
            margin: 0.15rem 0.15rem;
          }

          .type2 {
            width: 1px;
            height: 2.2rem;
            margin: 0.2rem 0.15rem;
            background: #242530;
          }

          .type3 {
            width: 4.38rem;
            height: 2.3rem;
            margin: 0.15rem 0.15rem;
          }

          .chart0 {
            margin-left: 1.17rem;
          }
        }
      }
    }

    .col,
    .row,
    .hoop {
      margin: 0.1rem;
      background: #2B2C3A;
      float: left;
      position: relative;
    }

    .wrap {
      margin: 0.2rem;
    }
  }
}
</style>
